import { AdversarialBadge } from '../badges/AdversarialBadge';
import { BondKindBadge } from '../badges/BondKindBadge';
import { ConflictAlertSeverityBadge } from '../badges/ConflictAlertSeverityBadge';
import { SequenceFlagBadge } from '../badges/SequenceFlagBadge';

import type { BondVM } from '../../view-models';
import type React from 'react';

export interface BondActivityCardProps {
  bond: BondVM;
  onSeeDetail?: (bond: BondVM) => void;
}

export function BondActivityCard({ bond, onSeeDetail }: BondActivityCardProps): React.JSX.Element {
  return (
    <div className={'bond-card' + (bond.adversarial === true ? ' bond-card--adversarial' : '')}>
      <div className="bond-card__head">
        <BondKindBadge
          kind={bond.kind}
          {...(bond.label !== undefined ? { label: bond.label } : {})}
          {...(bond.adversarial !== undefined ? { adversarial: bond.adversarial } : {})}
        />
        {bond.adversarial === true && <AdversarialBadge />}
      </div>
      <div className="bond-card__titular">Titular: {bond.titular}</div>
      <div className="bond-card__row">
        <span>
          <b>{bond.conversations}</b> conversas
        </span>
        {bond.sequences > 0 && (
          <span>
            <b>{bond.sequences}</b> sequence{bond.sequences === 1 ? '' : 's'}
          </span>
        )}
      </div>
      {((bond.flags?.length ?? 0) > 0 || bond.conflictAlerts !== undefined) && (
        <div className="bond-card__flags">
          {bond.flags?.map((f) => (
            <SequenceFlagBadge key={f} flag={f} />
          ))}
          {bond.conflictAlerts?.critical !== undefined && (
            <ConflictAlertSeverityBadge severity="critical" count={bond.conflictAlerts.critical} />
          )}
        </div>
      )}
      {/* Item 355: "Ver Bond detail" salta p/ a conversa mais recente do Bond
          (/atendimento/conversation/:id), cuja aba Cliente é a superfície canônica do Bond.
          Gate visual honesto (espelha o "Ver conversa atual" do SequenceRiskCard): desabilitado
          quando a page não passa o handler — sem core-conversation OU sem conversationId. */}
      <button
        type="button"
        className="btn-ghost-mini bond-card__action"
        disabled={onSeeDetail === undefined}
        title={
          onSeeDetail === undefined
            ? 'Disponível quando o Bond tem conversa vinculada e você pode abrir conversas'
            : undefined
        }
        onClick={() => onSeeDetail?.(bond)}
      >
        Ver detalhes do Bond
      </button>
    </div>
  );
}
